var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"value":_vm.value,"items":_vm.Countries,"label":"Select country","prepend-inner-icon":"mdi-map"},on:{"input":function($event){return _vm.$emit("input", $event)}}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }